module.exports = __webpack_public_path__ + "static_for_front/img/icon_file.99286c6b.jpg";